
import Toast from 'vux/src/components/toast/index.vue'

import { resolveMediaUrl } from '@/utils/mediaUrl'
import { TRIAL_WORD_LIMIT } from '@/utils/trialAccess'
import { buildMeanAndExampleHtml } from '@/utils/wordHighlight'

const FIELD_CONTROLLERS = {
mean: ['en', 'quiz'],
memory: ['en', 'quiz'],
word: ['zh'],
phonetic: ['zh'],
split: ['zh', 'quiz'],
ide: ['zh', 'quiz'],
image: ['quiz']
}

export default {
components: { Toast },
data () {
return {
book: {},
wordList: [],
index: 0,
detailedWord: {},
exchange: [],
loading: true,
wsongUrl: '',
showExtra: false,
showSummary: false,
elapsedTime: 0,
timer: null,
dictationStats: { correct: 0, wrong: 0, attempts: 0 },
showPositionValue: false,
toastText: '',
position: 'middle',
dictationInput: '',
fieldOverrides: {},
modes: {
en: { active: false, hidden: false },
zh: { active: false, hidden: false },
quiz: { active: false, hidden: false }
},
modeOptions: [
{ key: 'en', label: '英文' },
{ key: 'zh', label: '中文' },
{ key: 'quiz', label: '测验' }
],
highlightStyle: 'position:relative;color:#212121;background:#fff3b0;padding:2px 5px;border-radius:4px;',
audio: { playing: false, preload: 'auto' },
isWordPower: null,
touchStartX: 0,
touchStartY: 0,
wordNavigateStack: []
}
},
computed: {
isBookScope () {
return this.$route.query.scope === 'book'
},
scopeLabel () {
if (this.isBookScope) return '全书默写'
if (this.$route.query.unitCn) return this.$route.query.unitCn
return '单词默写'
},
progressPercent () {
if (!this.wordList.length) return 0
return Math.round(((this.index + 1) / this.wordList.length) * 100)
},
formattedTime () {
const minutes = Math.floor(this.elapsedTime / 60)
const seconds = this.elapsedTime % 60
return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
},
studiedCount () {
return this.wordList.length
},
avgTimePerWord () {
if (!this.studiedCount) return '0:00'
const avg = Math.round(this.elapsedTime / this.studiedCount)
const m = Math.floor(avg / 60)
const s = avg % 60
return `${m}:${s.toString().padStart(2, '0')}`
},
dictationAccuracy () {
if (!this.dictationStats.attempts) return 0
return Math.round((this.dictationStats.correct / this.dictationStats.attempts) * 100)
},
anyModeActive () {
return this.modes.en.active || this.modes.zh.active || this.modes.quiz.active
},
hasExtraContent () {
return this.hasExamples || this.exchange.length > 0
},
hasMultiWord () {
return this.detailedWord.english && this.detailedWord.english.indexOf(' ') > -1
},
englishParts () {
return (this.detailedWord.english || '').split(' ').filter(Boolean)
},
hasAnalysis () {
return this.detailedWord.wordSplit || this.detailedWord.wordIde || this.detailedWord.example
},
hasExamples () {
return this.detailedWord.modelSentence || this.detailedWord.modelText1
},
dictationPlaceholder () {
if (this.modes.en.active && !this.modes.zh.active) return '输入中文词义…'
if (this.modes.zh.active && !this.modes.en.active) return '输入英文单词…'
return '输入中/英文均可…'
},
emptyTip () {
if (this.$route.query.scope === 'book') return '暂无单词数据'
if (this.$route.query.cellId) return '该章节暂无单词'
return '请从练习页选择默写范围'
},
processedMean () {
if (!this.detailedWord || !this.detailedWord.mean) return ''
return buildMeanAndExampleHtml(this.detailedWord.mean, this.detailedWord.example, { style: this.highlightStyle }).processedMean
},
processedExample () {
if (!this.detailedWord || !this.detailedWord.mean || !this.detailedWord.example) {
return this.detailedWord.example || ''
}
return buildMeanAndExampleHtml(this.detailedWord.mean, this.detailedWord.example, { style: this.highlightStyle }).processedExample
},
processedWordSplit () {
if (!this.detailedWord || !this.detailedWord.wordSplit) return ''
const raw = String(this.detailedWord.wordSplit).replace(/<[^>]+>/g, '')
const plusStyle = this.wordPartPlusStyle()
const chipStyle = this.wordPartChipStyle(false)
return raw.split('+')
.map(p => p.trim())
.filter(Boolean)
.map(part => '<span class="word-part" style="' + chipStyle + '">' + this.escapeHtml(part) + '</span>')
.join('<span class="word-part-plus" style="' + plusStyle + '">+</span>')
},
processedWordIde () {
if (!this.detailedWord || !this.detailedWord.wordIde) return ''
const raw = String(this.detailedWord.wordIde).replace(/<[^>]+>/g, '')
const plusStyle = this.wordPartPlusStyle()
const that = this
return raw.split(/\s*\+\s*/)
.map(seg => that.formatIdeSegment(seg))
.join('<span class="word-part-plus" style="' + plusStyle + '">+</span>')
}
},
created () {
this.book = { ...this.$route.query }
this.isWordPower = this.$route.query.isWordPower
this.loadWordList()
},
mounted () {
this.$store.state.isShowBarKey = false
},
beforeDestroy () {
this.stopTimer()
},
watch: {
'$route' (to) {
if (to.name !== 'wordTest_display') return
this.book = { ...to.query }
this.resetSession(false)
this.loadWordList()
}
},
methods: {
loadWordList () {
const cellId = this.$route.query.cellId
const scope = this.$route.query.scope
if (cellId) {
this.loadUnitWords(cellId)
} else if (scope === 'book') {
this.loadAllBookWords()
} else {
this.loading = false
}
},
loadUnitWords (cellId) {
this.loading = true
this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: cellId })
.then(result => {
this.wordList = this.applyTrialWordCap(result || [])
this.startFirstWord()
})
.finally(() => { this.loading = false })
},
applyTrialWordCap (list) {
const power = this.isWordPower
if ((power === 0 || power === '0') && list.length > TRIAL_WORD_LIMIT) {
return list.slice(0, TRIAL_WORD_LIMIT)
}
return list
},
loadAllBookWords () {
this.loading = true
this.$ajax.post(this.$api.getUnitListByBookId, { planId: this.$route.query.value })
.then(units => {
const unitList = units || []
if (!unitList.length) {
this.wordList = []
return Promise.resolve([])
}
const limited = unitList.some(u => u.isWordPower === 0 || u.isWordPower === '0')
if (limited) {
this.isWordPower = 0
return this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: unitList[0].id })
.then(words => {
this.wordList = this.applyTrialWordCap(words || [])
this.startFirstWord()
})
.catch(() => { this.wordList = [] })
}
return Promise.all(
unitList.map(unit =>
this.$ajax.post(this.$api.gettreeUnitListByTotalId, { id: unit.id })
.then(words => words || [])
.catch(() => [])
)
).then(results => {
const merged = []
const seen = new Set()
results.flat().forEach(word => {
if (!word || !word.id || seen.has(word.id)) return
seen.add(word.id)
merged.push(word)
})
this.wordList = merged
this.startFirstWord()
})
})
.catch(() => { this.wordList = [] })
.finally(() => { this.loading = false })
},
startFirstWord () {
if (this.wordList.length) {
this.index = 0
this.startTimer()
this.getWordByid(this.wordList[0].id)
}
},
getWordByid (wordId) {
this.exchange = []
this.resetFieldOverrides()
this.dictationInput = ''
this.showExtra = false
this.detailedWord = { ...this.detailedWord, pmsImg: null }
this.$ajax.get(this.$api.getPmsPmsWordsById + '?pkId=' + wordId).then(response => {
this.detailedWord = response
if (this.detailedWord.pmsImg != null) {
this.detailedWord.pmsImg = resolveMediaUrl(this.detailedWord.pmsImg)
}
if (this.detailedWord.express) {
this.parseExchange(this.detailedWord.express)
}
if (this.$route.query.value) {
this.$ajax.post(this.$api.getPmsPmsStudyAdd, {
wordId: wordId,
wordUnitId: this.$route.query.value
})
}
})
},
parseExchange (expressStr) {
const exchangedata = JSON.parse(expressStr)
const labelMap = {
word_third: '第三人称单数', word_name: '原文query', word_means: '单词含义',
exchange: '不同时态', word_done: '过去式', word_pl: '复数', word_past: '过去分词',
word_ing: '现在分词', word_er: '比较级', word_proto: '原型', word_est: '最高级'
}
this.exchange = Object.keys(exchangedata).map(key => ({
wordct: labelMap[key] || key,
word: exchangedata[key]
}))
},
toggleMode (mode) {
const m = this.modes[mode]
if (!m.active) {
m.active = true
m.hidden = true
} else {
m.active = false
m.hidden = false
this.clearModeOverrides(mode)
}
},
clearModeOverrides (mode) {
Object.keys(FIELD_CONTROLLERS).forEach(key => {
if ((FIELD_CONTROLLERS[key] || []).includes(mode)) {
this.$delete(this.fieldOverrides, key)
}
})
},
toggleField (fieldKey) {
if (!this.isFieldControlled(fieldKey)) return
this.$set(this.fieldOverrides, fieldKey, !this.isFieldVisible(fieldKey))
},
isFieldControlled (fieldKey) {
return (FIELD_CONTROLLERS[fieldKey] || []).some(mode => this.modes[mode].active)
},
isFieldVisible (fieldKey) {
if (this.fieldOverrides[fieldKey] === true) return true
if (this.fieldOverrides[fieldKey] === false) return false
for (const mode of (FIELD_CONTROLLERS[fieldKey] || [])) {
const m = this.modes[mode]
if (m.active && m.hidden) return false
}
return true
},
zoneClasses (fieldKey) {
const controlled = this.isFieldControlled(fieldKey)
return {
'zone--controlled': controlled,
'zone--hidden': controlled && !this.isFieldVisible(fieldKey),
'zone--visible': controlled && this.isFieldVisible(fieldKey)
}
},
resetFieldOverrides () {
this.fieldOverrides = {}
},
checkDictation () {
const input = this.dictationInput.trim()
if (!input) {
this.toastText = '请先输入答案'
this.showPositionValue = true
return
}
let correct = false
if (this.modes.en.active && !this.modes.zh.active) {
correct = this.checkChineseAnswer(input)
} else if (this.modes.zh.active && !this.modes.en.active) {
correct = this.checkEnglishAnswer(input)
} else {
correct = this.checkChineseAnswer(input) || this.checkEnglishAnswer(input)
}
if (correct) {
this.toastText = '✓ 回答正确！'
this.dictationStats.correct++
this.revealAllControlled()
} else {
this.toastText = '再想想，不对哦'
this.dictationStats.wrong++
}
this.dictationStats.attempts++
this.showPositionValue = true
},
checkEnglishAnswer (input) {
const english = (this.detailedWord.english || '').trim().toLowerCase()
return input.trim().toLowerCase().replace(/\s+/g, ' ') === english
},
checkChineseAnswer (input) {
const mean = this.detailedWord.mean || ''
const keywords = this.extractKeywords(mean)
const cleaned = input.replace(/[^\u4e00-\u9fa5]/g, '')
if (!cleaned) return false
if (keywords.some(kw => {
if (kw.length < 2) return cleaned === kw
return cleaned.includes(kw) || kw.includes(cleaned)
})) return true
const plainMean = mean.replace(/<[^>]+>/g, '').replace(/[^\u4e00-\u9fa5]/g, '')
return cleaned.length >= 2 && plainMean.includes(cleaned)
},
revealAllControlled () {
Object.keys(FIELD_CONTROLLERS).forEach(key => {
if (this.isFieldControlled(key)) {
this.$set(this.fieldOverrides, key, true)
}
})
},
extractKeywords (meanText) {
const cleanedText = meanText.replace(/<[^>]+>/g, '').replace(/^.*?\s/, '').replace(/[^\u4e00-\u9fa5]+/g, ' ')
return [...new Set(cleanedText.split(/\s+/).filter(w => w.trim()))]
},
escapeHtml (unsafe) {
return String(unsafe).replace(/[&<"'>]/g, m => ({
'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
}[m]))
},
escapeRegExp (text) {
return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
},
wordPartChipStyle (isLink) {
const base = 'display:inline-block;font-weight:600;line-height:1.4;margin:0 1px;border-radius:4px;vertical-align:baseline;'
if (isLink) {
return base + 'color:#1989fa;background:#eef5ff;border:1px solid rgba(25,137,250,0.45);cursor:pointer;text-decoration:underline;text-underline-offset:2px;text-decoration-thickness:1px;'
}
return base + 'color:#555;background:#f4f7fb;border:1px solid #dde4ec;'
},
wordPartPlusStyle () {
return 'color:#b0bac5;font-weight:500;margin:0 3px;'
},
formatIdeSegment (segment) {
const trimmed = segment.trim()
const match = trimmed.match(/^(\w+)((?:[(（][^)）]+[)）]).*|(?:英文|拼音|象形|形象|音标|词根|口诀).*)$/)
if (!match) return this.escapeHtml(trimmed)
const word = match[1]
const rest = match[2]
const isEnglish = /^(?:[(（]英文[)）]|英文)/.test(rest)
const escapedWord = this.escapeHtml(word)
const chip = isEnglish
? '<span class="word-part word-part--link word-ide-link" style="' + this.wordPartChipStyle(true) + '" data-word="' + escapedWord + '">' + escapedWord + '</span>'
: '<span class="word-part" style="' + this.wordPartChipStyle(false) + '">' + escapedWord + '</span>'
return chip + this.escapeHtml(rest)
},
onWordIdeClick (e) {
const link = e.target.closest('.word-part--link')
if (link && link.dataset.word) {
e.preventDefault()
e.stopPropagation()
this.jumpToEnglishWord(link.dataset.word)
}
},
saveWordNavigateState () {
this.wordNavigateStack.push({
detailedWord: { ...this.detailedWord },
exchange: [...this.exchange],
index: this.index,
fieldOverrides: { ...this.fieldOverrides },
dictationInput: this.dictationInput,
showExtra: this.showExtra
})
},
restoreWordNavigateState () {
const prev = this.wordNavigateStack.pop()
if (!prev) return false
this.detailedWord = prev.detailedWord
this.exchange = prev.exchange
this.index = prev.index
this.fieldOverrides = prev.fieldOverrides
this.dictationInput = prev.dictationInput
this.showExtra = prev.showExtra
return true
},
clearWordNavigateStack () {
this.wordNavigateStack = []
},
jumpToEnglishWord (englishWord) {
this.saveWordNavigateState()
this.$ajax.get(this.$api.messageMessageBoardgetByWord + '?word=' + encodeURIComponent(englishWord) + '&type=back').then(response => {
if (response && response.length > 0) {
const pkId = response[0].id || response[0].wordId
if (!pkId) {
this.restoreWordNavigateState()
this.toastText = '未找到单词「' + englishWord + '」'
this.showPositionValue = true
return
}
this.getWordByid(pkId)
} else {
this.restoreWordNavigateState()
this.toastText = '未找到单词「' + englishWord + '」'
this.showPositionValue = true
}
}, () => {
this.restoreWordNavigateState()
this.toastText = '加载单词失败，请稍后重试'
this.showPositionValue = true
})
},
playA (url) {
if (!url) return
const audio = document.getElementById('waudio')
if (audio) {
audio.src = url
setTimeout(() => audio.play(), 200)
}
},
onPlay () { this.audio.playing = true },
onError () {},
onTouchStart (e) {

if (this.isBookScope) return
this.touchStartX = e.touches[0].clientX
this.touchStartY = e.touches[0].clientY
},
onTouchEnd (e) {
if (this.isBookScope) return
const dx = e.changedTouches[0].clientX - this.touchStartX
const dy = e.changedTouches[0].clientY - this.touchStartY
if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return
if (dx > 0) this.goPre()
else this.goNext()
},
goPre () {
if (this.index === 0) {
this.toastText = '已是第一个单词'
this.showPositionValue = true
return
}
this.clearWordNavigateStack()
this.index--
this.getWordByid(this.wordList[this.index].id)
},
goNext () {
if (this.isWordPower == 0 && this.index >= 4) {
this.toastText = '未开通该书仅可体验前5个单词，请兑换激活码后学习全部内容'
this.showPositionValue = true
this.finishStudy()
return
}
if (this.index >= this.wordList.length - 1) {
this.finishStudy()
return
}
this.clearWordNavigateStack()
this.index++
this.getWordByid(this.wordList[this.index].id)
},
finishStudy () {
this.stopTimer()
this.showSummary = true
},
startTimer () {
this.stopTimer()
this.elapsedTime = 0
this.timer = setInterval(() => {
this.elapsedTime++
}, 1000)
},
stopTimer () {
if (this.timer) {
clearInterval(this.timer)
this.timer = null
}
},
resetSession (keepWordList) {
this.stopTimer()
this.showSummary = false
this.index = 0
this.dictationStats = { correct: 0, wrong: 0, attempts: 0 }
this.clearWordNavigateStack()
this.modes = {
en: { active: false, hidden: false },
zh: { active: false, hidden: false },
quiz: { active: false, hidden: false }
}
this.fieldOverrides = {}
if (!keepWordList) {
this.wordList = []
}
},
restartStudy () {
this.resetSession(true)
this.startTimer()
if (this.wordList.length) {
this.getWordByid(this.wordList[0].id)
}
},
goReturn () {
if (this.wordNavigateStack.length > 0) {
this.restoreWordNavigateState()
return
}
if (this.$route.query.source) {
this.$router.push({ path: '/practiceSelectList_display?hideTrans=true', query: this.$route.query })
} else {
this.$router.push({ path: '/wordIndex?hideTrans=true' })
}
}
}
}



// WEBPACK FOOTER //
// ./src/views/word/practice/wordTest.vue